import { Branding } from '../constants';

export const decideLogoBasedOnPriority = (
	rsLogoUrl?: string | null,
	sfLogoUrl?: string | null
): string | null => {
	if (rsLogoUrl) {
		return rsLogoUrl;
	} else if (sfLogoUrl && sfLogoUrl !== Branding.NoLogoSet) {
		return sfLogoUrl;
	} else {
		return null;
	}
};
